import { __resetStyles, mergeClasses, shorthands } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const drawerHeaderNavigationClassNames = {
  root: 'fui-DrawerHeaderNavigation'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__resetStyles("rfs9jc2", "r4yk2e8", [".rfs9jc2{margin-top:calc(var(--spacingVerticalS) * -1);margin-right:calc(var(--spacingHorizontalL) * -1);margin-bottom:calc(var(--spacingVerticalS) * -1);margin-left:calc(var(--spacingHorizontalL) * -1);}", ".r4yk2e8{margin-top:calc(var(--spacingVerticalS) * -1);margin-left:calc(var(--spacingHorizontalL) * -1);margin-bottom:calc(var(--spacingVerticalS) * -1);margin-right:calc(var(--spacingHorizontalL) * -1);}"]);
/**
 * Apply styling to the DrawerHeaderNavigation slots based on the state
 */
export const useDrawerHeaderNavigationStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(drawerHeaderNavigationClassNames.root, styles, state.root.className);
  return state;
};
//# sourceMappingURL=useDrawerHeaderNavigationStyles.styles.js.map